import { loader2 } from './three-dot-loading.css';
import { Box } from '../box/box';

export const ThreeDotLoading = (props: any) => {
  // TODO@MK
  return <Box className={loader2} {...props}></Box>;
};
